<template>
  <div>
    <v-data-table
      :headers="headersRaccolta"
      :items="cardsRaccolta"
      item-key="_id"
      sort-by="tipo"
      class="elevation-1"
      dense
      hide-default-footer
      :single-expand="singleExpandRaccolta"
      :expanded.sync="expandedRaccolta"
      show-expand    
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="dialogRaccolta" max-width="1000px">
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" >
                      <v-text-field v-model="editedItemRaccolta.tipo" label="Tipo"></v-text-field> <!-- raccolta punti / buono / .. -->
                    </v-col>
                    <v-col cols="12" sm="6" md="4" > 
                      <v-text-field v-model="editedItemRaccolta._id" label="Codice"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" > 
                      <v-text-field v-model="editedItemRaccolta.dataAssociazione" label="Data Ass." ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" > 
                      <v-text-field v-model="editedItemRaccolta.raccoltaPunti.totale" label="Punti"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" > 
                      <v-text-field v-model="editedItemRaccolta.raccoltaPunti.ultimoAcquisto" label="Ultimo Acq."></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" > 
                      <v-text-field v-model="editedItemRaccolta.raccoltaPunti.numeroAcquisti" label="Numero Acq."></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" > 
                      <v-text-field v-model="editedItemRaccolta.status" label="Stato"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeRaccolta"
                >
                  Annulla
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="saveRaccolta"
                >
                  Salva
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDeleteRaccolta" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Sei sicuro di voler cancellare questa card?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDeleteRaccolta">Annulla</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemRaccoltaConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItemRaccolta(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItemRaccolta(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        Nessuna card definita
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="clientiSelected">
          <acquisti-card :idCliente="idCliente" :idCard="item._id" :raccolta="item.raccolta" />
        </td>
      </template>        
    </v-data-table>
    <hr />
    <v-data-table
    :headers="headersPrepagate"
    :items="cardsPrepagate"
    item-key="_id"
    sort-by="tipo"
    class="elevation-1"
    dense
    hide-default-footer
    :single-expand="singleExpandPrepagate"
    :expanded.sync="expandedPrepagate"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialogPrepagate" max-width="1000px">
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4" >
                    <v-text-field v-model="editedItemPrepagate.tipo" label="Tipo"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItemPrepagate._id" label="Codice"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItemPrepagate.dataAssociazione" label="Data Ass." ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItemPrepagate.prepagata.importoResiduo" label="Residuo"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItemPrepagate.prepagata.ultimoAcquisto" label="Ultimo Acq."></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItemPrepagate.prepagata.numeroAcquisti" label="Numero Acq."></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItemPrepagate.prepagata.ultimoCarico" label="Ultimo Carico"></v-text-field>
                  </v-col>                  
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItemPrepagate.status" label="Stato"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closePrepagate"
              >
                Annulla
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="savePrepagate"
              >
                Salva
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeletePrepagate" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Sei sicuro di voler cancellare questa card?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDeletePrepagate">Annulla</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemPrepagateConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItemPrepagate(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItemPrepagate(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      Nessuna card definita
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="clientiSelected">
        <acquisti-card :idCliente="idCliente" :idCard="item._id" :raccolta="item.buono" />
      </td>
    </template>        
    </v-data-table>     
  </div>
</template>

<script>
  import moment from 'moment'
  import fidelity from '@/services/fidelityService'
  import AcquistiCard from './dettagli/acquistiCard.vue'
  /* eslint-disable */
  export default {
    components: {
      AcquistiCard
    },
    props: {
      idCliente: String
    },
    data: () => ({
      dialogRaccolta: false,
      dialogPrepagate: false,
      dialogDeleteRaccolta: false,
      dialogDeletePrepagate: false,
      headersRaccolta: [
        {
          text: 'Tipo',
          align: 'start',
          sortable: false,
          value: 'tipo',
        },
        { text: 'Codice', value: '_id' },
        { text: 'Data Ass.', value: 'dataAssociazione' },
        { text: 'Punti', value: 'raccoltaPunti.totale' },
        { text: 'Ultimo Acq.', value: 'raccoltaPunti.ultimoAcquisto' },
        { text: 'Numero Acq.', value: 'raccoltaPunti.numeroAcquisti' },
        { text: 'Stato', value: 'status' },
        /* { text: 'Actions', value: 'actions', sortable: false }, */
        { text: '', value: 'data-table-expand' }
      ],
      headersPrepagate: [
        {
          text: 'Tipo',
          align: 'start',
          sortable: false,
          value: 'tipo',
        },
        { text: 'Codice', value: '_id' },
        { text: 'Data Ass.', value: 'dataAssociazione' },
        { text: 'Residuo', value: 'prepagata.importoResiduo' },
        { text: 'Ultimo Acq.', value: 'prepagata.ultimoAcquisto' },
        { text: 'Numero Acq.', value: 'prepagata.numeroAcquisti' },
        { text: 'Ultimo carico', value: 'prepagata.ultimoCarico' },
        { text: 'Stato', value: 'status' },
        /* { text: 'Actions', value: 'actions', sortable: false }, */
        { text: '', value: 'data-table-expand' }
      ],      
      cardsRaccolta: [],
      cardsPrepagate: [],
      editedIndex: -1,
      editedItemRaccolta: {
        tipo: '',
        _id: '',
        dataAssociazione: '',
        raccoltaPunti: {
          totale: '',
          ultimoAcquisto: '',
          numeroAcquisti: ''
        },
        status:  ''
      },
      editedItemPrepagate: {
        tipo: '',
        _id: '',
        dataAssociazione: '',
        prepagata: {
          importoResiduo: '',
          ultimoAcquisto: '',
          numeroAcquisti: '',
          ultimoCarico: ''
        },
        status:  ''
      },      
      defaultItemRaccolta: {
        tipo: '',
        _id: '',
        dataAssociazione: '',
        raccoltaPunti: {
          totale: '',
          ultimoAcquisto: '',
          numeroAcquisti: ''
        },
        status:  ''
      },
      defaultItemPrepagate: {
        tipo: '',
        _id: '',
        dataAssociazione: '',
        prepagata: {
          importoResiduo: '',
          ultimoAcquisto: '',
          numeroAcquisti: '',
          ultimoCarico: ''
        },
        status:  ''
      },      
      singleExpandRaccolta: false,
      expandedRaccolta: [],      
      singleExpandPrepagate: false,
      expandedPrepagate: []
    }),
    async mounted() {
      const elenco = await fidelity.cercaFidelityByCliente('', this.idCliente)
      this.cardsRaccolta = []
      this.cardsPrepagate = []    
      if (elenco.length === 0) {
         return
      }
      let newCardsRaccolta = []
      let newCardsPrepagate = []
      for (let cc of elenco.filter(x => x.tipo !== 'accesso')) {
        let tipo = 'Fidelity card'
        let card = {
          tipo: tipo,
          _id: cc._id,
          dataAssociazione: moment(cc.dataAssociazione).format('DD/MM/YYYY'),
          status: cc.status
        }
        if (cc.raccoltaPunti && cc.raccoltaPunti.abilita) {
          let numAcquisti = cc.raccoltaPunti.raccolta.length
          if (cc.raccoltaPunti.azzeramenti.length === 0 && cc.infoAggiuntive && cc.infoAggiuntive.numeroAccessi) {
            numAcquisti += cc.infoAggiuntive.numeroAccessi
          }
          card.tipo = 'Raccolta punti'
          card.raccoltaPunti = {
            totale: cc.raccoltaPunti.totale,
            ultimoAcquisto: (cc.raccoltaPunti.ultimoAcquisto ? moment(cc.raccoltaPunti.ultimoAcquisto).format('DD/MM/YYYY') : ''),
            numeroAcquisti: numAcquisti
          }
          card.raccolta = cc.raccoltaPunti.raccolta
          newCardsRaccolta.push(card)
        } else if (cc.buono && cc.buono.abilita) {
          card.tipo = 'Prepagata'
          const ultimoAcquisto = _.last(cc.buono.utilizzi)
          const ultimoCarico = _.last(cc.buono.carichi)
          card.prepagata = {
            importoResiduo: `${cc.buono.importoResiduo} €`,
            numeroAcquisti: cc.buono.utilizzi.length,
            carichi: cc.buono.carichi.length,
            ultimoAcquisto: ultimoAcquisto ? `${moment(ultimoAcquisto.data).format('DD/MM/YYYY')} (${ultimoAcquisto.importo} €)` : '',
            ultimoCarico: ultimoCarico ? `${moment(ultimoCarico.data).format('DD/MM/YYYY')} (${ultimoCarico.importo} €)` : '',
          }
          newCardsPrepagate.push(card)
        } else {
          newCardsRaccolta.push(card)
        }
      }
      Object.assign(this.cardsRaccolta, newCardsRaccolta)
      Object.assign(this.cardsPrepagate, newCardsPrepagate)
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuova card' : 'Modifica card'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDeleteRaccolta (val) {
        val || this.closeDeleteRaccolta()
      },
      dialogDeletePrepagate (val) {
        val || this.closeDeletePrepagate()
      }
    },
    methods: {
      editItemRaccolta (item) {
        this.editedIndex = this.cardsRaccolta.indexOf(item)
        this.editedItemRaccolta = Object.assign({}, item)
        this.dialogRaccolta = true
      },

      deleteItemRaccolta (item) {
        this.editedIndex = this.cardsRaccolta.indexOf(item)
        this.editedItemRaccolta = Object.assign({}, item)
        this.dialogDeleteRaccolta = true
      },

      deleteItemRaccoltaConfirm () {
        this.cardsRaccolta.splice(this.editedIndex, 1)
        this.closeDeleteRaccolta()
      },

      closeRaccolta () {
        this.dialogRaccolta = false
        this.$nextTick(() => {
          this.editedItemRaccolta = Object.assign({}, this.defaultItemRaccolta)
          this.editedIndex = -1
        })
      },

      closeDeleteRaccolta () {
        this.dialogDeleteRaccolta = false
        this.$nextTick(() => {
          this.editedItemRaccolta = Object.assign({}, this.defaultItemRaccolta)
          this.editedIndex = -1
        })
      },

      saveRaccolta () {
        // Il savataggio deve essere fatto da qui, la card è su un db diverso da quello del cliente

/*         if (this.editedIndex > -1) {
          Object.assign(this.cards[this.editedIndex], this.editedItem)
          this.$emit('update-address', this.idCliente, this.editItem)
        } else {
          this.$emit('new-address', this.idCliente, this.editItem)
          this.cards.push(this.editedItem)
        } */
        this.closeRaccolta()
      },
      editItemPrepagate (item) {
        this.editedIndex = this.cardsPrepagate.indexOf(item)
        this.editedItemPrepagate = Object.assign({}, item)
        this.dialogPrepagate = true
      },

      deleteItemPrepagate (item) {
        this.editedIndex = this.cardsPrepagate.indexOf(item)
        this.editedItemPrepagate = Object.assign({}, item)
        this.dialogDeletePrepagate = true
      },

      deleteItemPrepagateConfirm () {
        this.cardsPrepagate.splice(this.editedIndex, 1)
        this.closeDeletePrepagate()
      },

      closePrepagate () {
        this.dialogPrepagate = false
        this.$nextTick(() => {
          this.editedItemPrepagate = Object.assign({}, this.defaultItemPrepagate)
          this.editedIndex = -1
        })
      },

      closeDeletePrepagate () {
        this.dialogDeletePrepagate = false
        this.$nextTick(() => {
          this.editedItemPrepagate = Object.assign({}, this.defaultItemPrepagate)
          this.editedIndex = -1
        })
      },      
      savePrepagate () {
        this.closePrepagate()
      },      
      onChangeTipo(item) {

      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
  td.clientiSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
